const actions = {
  SET_STATE: "tagGroup/SET_STATE",
  LIST: "tagGroup/LIST",
  CREATE: "tagGroup/CREATE",
  DETAIL: "tagGroup/DETAIL",
  UPDATE: "tagGroup/UPDATE",
  DELETE: "tagGroup/DELETE",
};

export default actions;
